module.exports = __webpack_public_path__ + "fonts/nunitosans-black-webfont.2824a74.woff2";